import { render, staticRenderFns } from "./CustomViewColumnEditor.vue?vue&type=template&id=1655cbf4&scoped=true"
import script from "./CustomViewColumnEditor.vue?vue&type=script&lang=js"
export * from "./CustomViewColumnEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1655cbf4",
  null
  
)

export default component.exports